'use strict';

var container = $('#our-locations-section');
var url = container.data('url');

/**
 * Filters stores based on search text matching store name, address, phone number or city
 * @param {string} searchText - The search text to filter by
 */
function filterStores(searchText) {
    const searchLower = searchText.toLowerCase().trim();
    const carousel = container.find('.store-carousel');
    const isSlickInitialized = carousel.hasClass('slick-initialized');
    const noStoresMessage = container.find('.no-stores-message');
    let hasMatches = false;

    const checkMatch = function (store) {
        if (!searchLower) return true;

        const storeName = store.querySelector('.heading') ? store.querySelector('.heading').textContent.toLowerCase() : '';
        const storeAddress = store.querySelector('.store-address') ? store.querySelector('.store-address').textContent.toLowerCase() : '';
        const storeCity = store.querySelector('.store-city') ? store.querySelector('.store-city').textContent.toLowerCase() : '';
        const storePhone = store.querySelector('.store-contact-number') ? store.querySelector('.store-contact-number').textContent.replace(/[\s+-]/g, '').toLowerCase() : '';
        const isMatch = storeName.includes(searchLower) || storeAddress.includes(searchLower) || storeCity.includes(searchLower) || storePhone.includes(searchLower);
        if (isMatch) hasMatches = true;
        return isMatch;
    };

    if (isSlickInitialized) {
        carousel.slick('slickUnfilter');
        if (searchLower) {
            carousel.slick('slickFilter', function () {
                return checkMatch(this);
            });
        }
    } else {
        const stores = document.querySelectorAll('.store-card');
        stores.forEach(store => {
            if (checkMatch(store)) {
                store.style.display = '';
            } else {
                store.style.display = 'none';
            }
        });
    }

    if (searchLower && !hasMatches) {
        noStoresMessage.removeClass('d-none');
    } else {
        noStoresMessage.addClass('d-none');
    }
}

// Make filterStores globally available
window.filterStores = filterStores;

/**
 * Initializes the Slick carousel on elements with the 'store-carousel' class
 * inside the container. Sets responsive behavior for screen sizes below 1024px.
 */
function initializeSlick() {
    container.find('.store-carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4.1495,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: 'unslick'
            }
        ]
    });
}

/**
 * Initializes the Slick carousel only if the screen width is 1024px or more
 * and the carousel has not already been initialized.
 */
function handleSlick() {
    if (window.innerWidth >= 1024) {
        if (!container.find('.store-carousel').hasClass('slick-initialized')) {
            initializeSlick();
        }
    }
}

$(window).on('resize', function () {
    handleSlick();
});

$.ajax({
    url: url,
    method: 'GET',
    success: function (html) {
        container.html(html);
        handleSlick(); // Init based on screen width
    },
    error: function () {
        // TODO: Error scenario
    }
});

/**
 * Opens the store link in a new tab if allowed by the current
 * viewport and options.
 *
 * @param {JQuery} storeCard - jQuery element representing the store card.
 * @param {{ desktopOnly: boolean, requireExpandedOnMobile: boolean }} options -
 *     Configuration options controlling when the link should open.
 */
function openStoreLinkIfAllowed(storeCard, options) {
    var link = storeCard.data('link');
    if (!link) return;

    var isDesktop = window.innerWidth >= 1024;

    if (!isDesktop && options.desktopOnly) {
        return;
    }

    if (!isDesktop && options.requireExpandedOnMobile) {
        if (storeCard.find('.accordian-header').hasClass('collapsed')) {
            return;
        }
    }

    window.open(link, '_blank');
}

$('body').on('click', '.store-card .accordian-body', function (e) {
    // Prevent click when clicking on inner anchor links
    if (e.target.tagName.toLowerCase() === 'a') return;
    var storeCard = $(this).closest('.store-card');

    openStoreLinkIfAllowed(storeCard, {
        desktopOnly: false,
        requireExpandedOnMobile: true
    });
});

$('body').on('click', '.store-card,  .store-card .accordian-header', function (e) {
    // Let inner anchor tags handle their own navigation
    if (e.target.tagName.toLowerCase() === 'a') return;

    var storeCard = $(this).closest('.store-card');

    openStoreLinkIfAllowed(storeCard, {
        desktopOnly: true,
        requireExpandedOnMobile: false
    });
});
